<template>
  <div class="layout_container">
    <header-section />
    <top-section />
    <main-section />
    <footer-com />
  </div>
</template>

<script>
import HeaderSection from './components/header'
import TopSection from './components/topSection'
import MainSection from './components/main'
import FooterCom from './components/footer'
export default {
  name: 'HomePage',
  components: {
    HeaderSection,
    TopSection,
    // AdInfoFlow,
    MainSection,
    FooterCom,
  },
  data() {
    return {
      targetElement: null,
      observerElement: null,
    }
  },
  mounted() {
    // this.targetElement = document.querySelector('#header')
    // this.observerElement = document.querySelector('#company-history')
    // window.addEventListener('scroll', this.checkIntersection)
  },
  methods: {
    // checkIntersection() {
    //   const targetRect = this.targetElement.getBoundingClientRect()
    //   const observerRect = this.observerElement.getBoundingClientRect()
    //   const isIntersecting =
    //     targetRect.top < observerRect.bottom &&
    //     targetRect.bottom > observerRect.top &&
    //     targetRect.left < observerRect.right &&
    //     targetRect.right > observerRect.left
    //   if (isIntersecting) {
    //     this.targetElement.classList.add('header-bg-black')
    //   } else {
    //     this.targetElement.classList.remove('header-bg-black')
    //   }
    // },
  },
}
</script>

<style>
html {
  scroll-behavior: smooth; /* 启用平滑滚动 */
}
</style>
